module.exports = __webpack_public_path__ + "img/newsletter14.480478fc.jpeg";